<template>
    <div>
        <div class="modal hide fade" id="modalPurchasing" tabindex="-1" role="dialog" aria-labelledby="modalPurchasing" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            <span>Pembelian - {{ purchasing.purchasing_no }}</span>
                            <span class="badge badge-success ml-1" v-if="purchasing.status === 'approve'">{{ purchasing.status }}</span>
                            <span class="badge badge-warning ml-1" v-else>{{ purchasing.status }}</span>
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <dl class="row dl-customer">
                                    <dt class="col-md-4">Invoice No.</dt>
                                    <dd class="col-md-8">{{ purchasing.ext_no }}</dd>

                                    <dt class="col-md-4">Tanggal</dt>
                                    <dd class="col-md-8">{{ purchasing.purchasing_date | dateFormat('DD/MM/YYYY') }}</dd>

                                    <dt class="col-md-4">Tanggal Jatuh Tempo</dt>
                                    <dd class="col-md-8">{{ purchasing.purchasing_due_date | dateFormat('DD/MM/YYYY') }}</dd>

                                    <dt class="col-md-4">Vendor</dt>
                                    <dd class="col-md-8">{{ purchasing.vendor }}</dd>
                                </dl>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs nav-bordered">
                                    <li class="nav-item">
                                        <a href="#purchasing-modal-tab" data-toggle="tab" aria-expanded="false" class="nav-link active">Purchasing</a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#purchasing-payment-tab" data-toggle="tab" aria-expanded="false" class="nav-link">Payment</a>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <div class="tab-pane active" id="purchasing-modal-tab">
                                        <div class="table-responsive">
                                            <table class="table table-item table-sm table-hover table-striped">
                                                <thead>
                                                    <th>Product</th>
                                                    <th>Qty</th>
                                                    <th>Uom</th>
                                                    <th class="text-right">Price</th>
                                                    <th class="text-right">Discount</th>
                                                    <th class="text-right">Subtotal(DPP)</th>
                                                    <th class="text-right">Tax</th>
                                                    <th class="text-right">Total</th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="d in purchasing.details" :key="d.id">
                                                        <td><b>[{{ d.product_no }}]</b> {{ d.product }}</td>
                                                        <td>{{ d.qty }}</td>
                                                        <td>{{ d.uom_id }}</td>
                                                        <td class="text-right">{{ d.price}}</td>
                                                        <td class="text-right">{{ d.discount_percentage}} %</td>
                                                        <td class="text-right">{{ d.subtotal}}</td>
                                                        <td class="text-right">{{ d.tax}}</td>
                                                        <td class="text-right">{{ d.total}}</td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td class="text-right font-13" colspan="7"><b>Subtotal</b></td>
                                                        <td class="text-right">{{ purchasing.subtotal }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-right font-13" colspan="7"><b>Discount</b></td>
                                                        <td class="text-right">{{ purchasing.discount }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-right font-13" colspan="7"><b>Tax</b></td>
                                                        <td class="text-right">{{ purchasing.tax }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-right font-13" colspan="7"><b>Total</b></td>
                                                        <td class="text-right">{{ purchasing.total }}</td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="purchasing-payment-tab">
                                        <pre>{{ purchasing.payments }}</pre>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <router-link :to="'/purchasing?form=true&purchasing=' + purchasing.id" class="btn btn-hard-primary" target="_blank">Approve</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'PurchasingModal',
  computed: {
    ...mapState({
      purchasing: state => state.purchasings.purchasingShowByNo
    })
  }
}
</script>
